// extracted by css-extract-rspack-plugin
export default {"sidebar":"FindingsSidebar-module__sidebar__FVZVc","taskContent":"FindingsSidebar-module__taskContent__zb2MQ","taskTitle":"FindingsSidebar-module__taskTitle__zEZDI"};